export const testGame_players = [
  {
    player_stat_id: 9,
    player_id: "43isaak_hayes",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 43,
    field_goals_made: 4,
    field_goals_attempted: 9,
    three_pointers_made: 1,
    three_pointers_attempted: 3,
    free_throws_made: 2,
    free_throws_attempted: 2,
    offensive_rebounds: 2,
    defensive_rebounds: 3,
    total_rebounds: 5,
    personal_fouls: 4,
    points: 11,
    assists: 1,
    turnovers: 1,
    blocks: 0,
    steals: 1,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Isaak Hayes",
    image_url:
      "https://pbs.twimg.com/profile_images/1699802153424916480/qynVB1MT_400x400.jpg",
  },
  {
    player_stat_id: 10,
    player_id: "46jax_sharum",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 46,
    field_goals_made: 0,
    field_goals_attempted: 2,
    three_pointers_made: 0,
    three_pointers_attempted: 2,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 0,
    total_rebounds: 1,
    personal_fouls: 1,
    points: 0,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 1,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Jax Sharum",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/03/IMG_2584.jpg?w=480",
  },
  {
    player_stat_id: 18,
    player_id: "4dylan_franklin",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 4,
    field_goals_made: 3,
    field_goals_attempted: 6,
    three_pointers_made: 2,
    three_pointers_attempted: 2,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 2,
    defensive_rebounds: 2,
    total_rebounds: 4,
    personal_fouls: 0,
    points: 8,
    assists: 0,
    turnovers: 0,
    blocks: 1,
    steals: 0,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "Dylan Franklin",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/06/tempImagezHnR1n-rotated.jpg?w=768",
  },
  {
    player_stat_id: 11,
    player_id: "53xavier_young",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 53,
    field_goals_made: 1,
    field_goals_attempted: 1,
    three_pointers_made: 1,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 3,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Xavier Young",
    image_url:
      "https://static.hudl.com/users/prod/7045741_95ea1a4d354d45409992883b9722793c.jpg",
  },
  {
    player_stat_id: 12,
    player_id: "59jacari_irvin",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 59,
    field_goals_made: 2,
    field_goals_attempted: 4,
    three_pointers_made: 1,
    three_pointers_attempted: 3,
    free_throws_made: 0,
    free_throws_attempted: 1,
    offensive_rebounds: 1,
    defensive_rebounds: 2,
    total_rebounds: 3,
    personal_fouls: 0,
    points: 5,
    assists: 0,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Jacari Irvin",
    image_url:
      "https://pbs.twimg.com/profile_images/1787190900969414656/L_B260jR_400x400.jpg",
  },
  {
    player_stat_id: 19,
    player_id: "5darren_ford",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 5,
    field_goals_made: 1,
    field_goals_attempted: 5,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 2,
    total_rebounds: 2,
    personal_fouls: 2,
    points: 2,
    assists: 1,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "Darren Ford",
    image_url:
      "https://static.hudl.com/users/prod/15349013_8184aacf7bb14161ba4858612a95d8a7.jpg",
  },
  {
    player_stat_id: 15,
    player_id: "81jonathan_cayetan",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 81,
    field_goals_made: 1,
    field_goals_attempted: 1,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 1,
    offensive_rebounds: 1,
    defensive_rebounds: 1,
    total_rebounds: 2,
    personal_fouls: 2,
    points: 2,
    assists: 2,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "10.00",
    additional_stats: null,
    player_name: "Jonathan Cayetan",
    image_url:
      "https://static.hudl.com/users/prod/19428833_589480b521114879b91370a1110fe7d0.jpg",
  },
  {
    player_stat_id: 16,
    player_id: "82camren_edwards",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 82,
    field_goals_made: 0,
    field_goals_attempted: 2,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 2,
    free_throws_attempted: 3,
    offensive_rebounds: 1,
    defensive_rebounds: 1,
    total_rebounds: 2,
    personal_fouls: 1,
    points: 2,
    assists: 0,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "11.00",
    additional_stats: null,
    player_name: "Camren Edwards",
    image_url:
      "https://static.hudl.com/users/temp/17209207_f08dbc6e340a4cbe842a5f2b2dba6730.jpg",
  },
  {
    player_stat_id: 17,
    player_id: "0malachi_booker",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 0,
    field_goals_made: 5,
    field_goals_attempted: 11,
    three_pointers_made: 0,
    three_pointers_attempted: 5,
    free_throws_made: 1,
    free_throws_attempted: 1,
    offensive_rebounds: 1,
    defensive_rebounds: 1,
    total_rebounds: 2,
    personal_fouls: 0,
    points: 11,
    assists: 2,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Malachi Booker",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/11/Malachi-Booker-Prep-Hoops-Article.jpg?w=768",
  },
  {
    player_stat_id: 1,
    player_id: "10zylan_bernard",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 10,
    field_goals_made: 2,
    field_goals_attempted: 8,
    three_pointers_made: 0,
    three_pointers_attempted: 2,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 1,
    total_rebounds: 2,
    personal_fouls: 0,
    points: 4,
    assists: 1,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Zylan Bernard",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/10/54E37909-D1CE-4379-AABA-A81E69FF923E.jpeg?w=768",
  },
  {
    player_stat_id: 20,
    player_id: "12terrell_jackson",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 12,
    field_goals_made: 0,
    field_goals_attempted: 1,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 2,
    free_throws_attempted: 2,
    offensive_rebounds: 0,
    defensive_rebounds: 3,
    total_rebounds: 3,
    personal_fouls: 1,
    points: 2,
    assists: 0,
    turnovers: 1,
    blocks: 2,
    steals: 0,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "Terrell Jackson",
    image_url:
      "https://pbs.twimg.com/profile_images/1749621752299216898/rhi3Zo86_400x400.jpg",
  },
  {
    player_stat_id: 2,
    player_id: "16xander_pruzinsky",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 16,
    field_goals_made: 4,
    field_goals_attempted: 8,
    three_pointers_made: 0,
    three_pointers_attempted: 2,
    free_throws_made: 2,
    free_throws_attempted: 2,
    offensive_rebounds: 3,
    defensive_rebounds: 3,
    total_rebounds: 6,
    personal_fouls: 0,
    points: 10,
    assists: 2,
    turnovers: 0,
    blocks: 2,
    steals: 1,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Xander Pruzinsky",
    image_url:
      "https://static.hudl.com/users/prod/21067162_037dbaeb04f144d3bda08377ac11cb07.jpg",
  },
  {
    player_stat_id: 3,
    player_id: "17nehemiah_davis",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 17,
    field_goals_made: 0,
    field_goals_attempted: 4,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 1,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 0,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Nehemiah Davis",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/11/BJ-Davis-Ray-Prep-Hoops-Article.jpg?w=768",
  },
  {
    player_stat_id: 21,
    player_id: "20avery_hudson",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 20,
    field_goals_made: 2,
    field_goals_attempted: 6,
    three_pointers_made: 1,
    three_pointers_attempted: 3,
    free_throws_made: 2,
    free_throws_attempted: 2,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 7,
    assists: 3,
    turnovers: 0,
    blocks: 0,
    steals: 1,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "Avery Hudson",
    image_url:
      "https://static.hudl.com/users/prod/3603957_296033834ca64ffebaad7cdeac6bf422.jpg",
  },
  {
    player_stat_id: 4,
    player_id: "22alex_alexander",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 22,
    field_goals_made: 1,
    field_goals_attempted: 1,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 2,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Alex Alexander",
    image_url:
      "https://wssurams.com/images/2022/6/3/alexander_reed_m_baskbl_2021_22.jpg?width=300",
  },
  {
    player_stat_id: 22,
    player_id: "24amare_johnson",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 24,
    field_goals_made: 0,
    field_goals_attempted: 0,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 2,
    points: 0,
    assists: 2,
    turnovers: 1,
    blocks: 0,
    steals: 1,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "Amare Johnson",
    image_url:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9CsknllbQA8hap0oEjG1KzRzIzQc_Jyaq5Q&s",
  },
  {
    player_stat_id: 5,
    player_id: "24cadarian_urune",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 24,
    field_goals_made: 1,
    field_goals_attempted: 5,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 2,
    free_throws_attempted: 3,
    offensive_rebounds: 1,
    defensive_rebounds: 0,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 4,
    assists: 2,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Cadarian Urune",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/08/CadarianUrune.jpg?w=768",
  },
  {
    player_stat_id: 23,
    player_id: "25steven_mcleod",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 25,
    field_goals_made: 1,
    field_goals_attempted: 3,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 4,
    free_throws_attempted: 4,
    offensive_rebounds: 1,
    defensive_rebounds: 1,
    total_rebounds: 2,
    personal_fouls: 0,
    points: 6,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "Steven McLeod",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/04/IMG_7773-crop-1818x1194-1681953473.jpeg?w=768",
  },
  {
    player_stat_id: 6,
    player_id: "28david_baliraine",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 28,
    field_goals_made: 2,
    field_goals_attempted: 4,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 3,
    total_rebounds: 4,
    personal_fouls: 1,
    points: 4,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "David Baliraine",
    image_url: "https://pbs.twimg.com/media/GN4vfbwbEAAmmdU.jpg:large",
  },
  {
    player_stat_id: 7,
    player_id: "31reese_alston",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 31,
    field_goals_made: 5,
    field_goals_attempted: 7,
    three_pointers_made: 3,
    three_pointers_attempted: 3,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 2,
    total_rebounds: 3,
    personal_fouls: 1,
    points: 13,
    assists: 3,
    turnovers: 1,
    blocks: 0,
    steals: 1,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Reese Alston",
    image_url:
      "https://s3media.247sports.com/Uploads/Assets/109/611/12611109.jpeg",
  },
  {
    player_stat_id: 24,
    player_id: "32james_spears",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 32,
    field_goals_made: 3,
    field_goals_attempted: 5,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 2,
    total_rebounds: 3,
    personal_fouls: 0,
    points: 6,
    assists: 1,
    turnovers: 1,
    blocks: 1,
    steals: 0,
    minutes_played: "17.00",
    additional_stats: null,
    player_name: "James Spears",
    image_url: "https://pbs.twimg.com/media/E8E0lBAUcAI8t3-.jpg:large",
  },
  {
    player_stat_id: 8,
    player_id: "34dawson_battie",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 34,
    field_goals_made: 4,
    field_goals_attempted: 5,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 3,
    total_rebounds: 4,
    personal_fouls: 1,
    points: 8,
    assists: 0,
    turnovers: 0,
    blocks: 1,
    steals: 0,
    minutes_played: "16.00",
    additional_stats: null,
    player_name: "Dawson Battie",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/10/54E37909-D1CE-4379-AABA-A81E69FF923E.jpeg?w=768",
  },
  {
    player_stat_id: 25,
    player_id: "36brandon_lohmann",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 36,
    field_goals_made: 0,
    field_goals_attempted: 0,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 0,
    total_rebounds: 0,
    personal_fouls: 0,
    points: 0,
    assists: 0,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Brandon Lohmann",
    image_url:
      "https://sportspassports.com/wp-content/uploads/player-profiles/brandon-lohmann_5526.jpg?get_fresh=1731048481",
  },
  {
    player_stat_id: 26,
    player_id: "48brandon_brooks",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 48,
    field_goals_made: 2,
    field_goals_attempted: 5,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 2,
    defensive_rebounds: 3,
    total_rebounds: 5,
    personal_fouls: 3,
    points: 4,
    assists: 0,
    turnovers: 2,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Brandon Brooks",
    image_url:
      "https://image.maxpreps.io/rosters/dda64431-2648-4256-9dd3-2e626fa044dd/7/d/8/7d8c0864-cf60-45ed-9571-0281157ff918/original.jpg",
  },
  {
    player_stat_id: 27,
    player_id: "61daylan_jackson",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 61,
    field_goals_made: 3,
    field_goals_attempted: 3,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 0,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 6,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Daylan Jackson",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/11/Malachi-Booker-Prep-Hoops-Article.jpg?w=768",
  },
  {
    player_stat_id: 13,
    player_id: "62tristan_coleman",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 62,
    field_goals_made: 1,
    field_goals_attempted: 1,
    three_pointers_made: 0,
    three_pointers_attempted: 0,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 2,
    assists: 0,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Tristan Coleman",
    image_url:
      "https://sportspassports.com/wp-content/uploads/player-profiles/tristan-coleman_46844.jpg",
  },
  {
    player_stat_id: 28,
    player_id: "75brodrick_wyatt",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 75,
    field_goals_made: 2,
    field_goals_attempted: 5,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 1,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 4,
    assists: 1,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Brodrick Wyatt",
    image_url:
      "https://pbs.twimg.com/profile_images/1732868637071900673/4X0otdjP_400x400.jpg",
  },
  {
    player_stat_id: 14,
    player_id: "77galen_roberts",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_black",
    jersey_number: 77,
    field_goals_made: 6,
    field_goals_attempted: 7,
    three_pointers_made: 1,
    three_pointers_attempted: 2,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 0,
    defensive_rebounds: 0,
    total_rebounds: 0,
    personal_fouls: 1,
    points: 13,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 1,
    minutes_played: "12.00",
    additional_stats: null,
    player_name: "Galen Roberts",
    image_url:
      "https://pbs.twimg.com/profile_images/1725435732595032064/ChMtvvbI_400x400.jpg",
  },
  {
    player_stat_id: 29,
    player_id: "81josiah_jones",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 81,
    field_goals_made: 1,
    field_goals_attempted: 6,
    three_pointers_made: 1,
    three_pointers_attempted: 2,
    free_throws_made: 1,
    free_throws_attempted: 2,
    offensive_rebounds: 2,
    defensive_rebounds: 1,
    total_rebounds: 3,
    personal_fouls: 1,
    points: 4,
    assists: 0,
    turnovers: 0,
    blocks: 0,
    steals: 1,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Josiah Jones",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/03/tempImageaxVIb8-rotated.jpg?w=768",
  },
  {
    player_stat_id: 30,
    player_id: "88carter_coleman",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 88,
    field_goals_made: 0,
    field_goals_attempted: 3,
    three_pointers_made: 0,
    three_pointers_attempted: 1,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 0,
    total_rebounds: 1,
    personal_fouls: 0,
    points: 0,
    assists: 1,
    turnovers: 0,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Carter Coleman",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/05/IMG_6245.jpg?w=768",
  },
  {
    player_stat_id: 31,
    player_id: "96christopher_hunt",
    game_id: "top_30_black_vs_top_30_white",
    team_id: "top_30_white",
    jersey_number: 96,
    field_goals_made: 5,
    field_goals_attempted: 11,
    three_pointers_made: 1,
    three_pointers_attempted: 5,
    free_throws_made: 0,
    free_throws_attempted: 0,
    offensive_rebounds: 1,
    defensive_rebounds: 4,
    total_rebounds: 5,
    personal_fouls: 0,
    points: 11,
    assists: 2,
    turnovers: 1,
    blocks: 0,
    steals: 0,
    minutes_played: "15.00",
    additional_stats: null,
    player_name: "Christopher Hunt",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/03/IMG_2584.jpg?w=480",
  },
];

export const playersById = {
  "43isaak_hayes": {
    player_name: "Isaak Hayes",
    image_url:
      "https://pbs.twimg.com/profile_images/1699802153424916480/qynVB1MT_400x400.jpg",
  },
  "46jax_sharum": {
    player_name: "Jax Sharum",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/03/IMG_2584.jpg?w=480",
  },
  "4dylan_franklin": {
    player_name: "Dylan Franklin",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/06/tempImagezHnR1n-rotated.jpg?w=768",
  },
  "53xavier_young": {
    player_name: "Xavier Young",
    image_url:
      "https://static.hudl.com/users/prod/7045741_95ea1a4d354d45409992883b9722793c.jpg",
  },
  "59jacari_irvin": {
    player_name: "Jacari Irvin",
    image_url:
      "https://pbs.twimg.com/profile_images/1787190900969414656/L_B260jR_400x400.jpg",
  },
  "5darren_ford": {
    player_name: "Darren Ford",
    image_url:
      "https://static.hudl.com/users/prod/15349013_8184aacf7bb14161ba4858612a95d8a7.jpg",
  },
  "81jonathan_cayetan": {
    player_name: "Jonathan Cayetan",
    image_url:
      "https://static.hudl.com/users/prod/19428833_589480b521114879b91370a1110fe7d0.jpg",
  },
  "82camren_edwards": {
    player_name: "Camren Edwards",
    image_url:
      "https://static.hudl.com/users/temp/17209207_f08dbc6e340a4cbe842a5f2b2dba6730.jpg",
  },
  "0malachi_booker": {
    player_name: "Malachi Booker",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/11/Malachi-Booker-Prep-Hoops-Article.jpg?w=768",
  },
  "10zylan_bernard": {
    player_name: "Zylan Bernard",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/10/54E37909-D1CE-4379-AABA-A81E69FF923E.jpeg?w=768",
  },
  "12terrell_jackson": {
    player_name: "Terrell Jackson",
    image_url:
      "https://pbs.twimg.com/profile_images/1749621752299216898/rhi3Zo86_400x400.jpg",
  },
  "16xander_pruzinsky": {
    player_name: "Xander Pruzinsky",
    image_url:
      "https://static.hudl.com/users/prod/21067162_037dbaeb04f144d3bda08377ac11cb07.jpg",
  },
  "17nehemiah_davis": {
    player_name: "Nehemiah Davis",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/11/BJ-Davis-Ray-Prep-Hoops-Article.jpg?w=768",
  },
  "20avery_hudson": {
    player_name: "Avery Hudson",
    image_url:
      "https://static.hudl.com/users/prod/3603957_296033834ca64ffebaad7cdeac6bf422.jpg",
  },
  "22alex_alexander": {
    player_name: "Alex Alexander",
    image_url:
      "https://wssurams.com/images/2022/6/3/alexander_reed_m_baskbl_2021_22.jpg?width=300",
  },
  "24amare_johnson": {
    player_name: "Amare Johnson",
    image_url:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9CsknllbQA8hap0oEjG1KzRzIzQc_Jyaq5Q&s",
  },
  "24cadarian_urune": {
    player_name: "Cadarian Urune",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/08/CadarianUrune.jpg?w=768",
  },
  "25steven_mcleod": {
    player_name: "Steven McLeod",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/04/IMG_7773-crop-1818x1194-1681953473.jpeg?w=768",
  },
  "28david_baliraine": {
    player_name: "David Baliraine",
    image_url: "https://pbs.twimg.com/media/GN4vfbwbEAAmmdU.jpg:large",
  },
  "31reese_alston": {
    player_name: "Reese Alston",
    image_url:
      "https://s3media.247sports.com/Uploads/Assets/109/611/12611109.jpeg",
  },
  "32james_spears": {
    player_name: "James Spears",
    image_url: "https://pbs.twimg.com/media/E8E0lBAUcAI8t3-.jpg:large",
  },
  "34dawson_battie": {
    player_name: "Dawson Battie",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/10/54E37909-D1CE-4379-AABA-A81E69FF923E.jpeg?w=768",
  },
  "36brandon_lohmann": {
    player_name: "Brandon Lohmann",
    image_url:
      "https://sportspassports.com/wp-content/uploads/player-profiles/brandon-lohmann_5526.jpg?get_fresh=1731048481",
  },
  "48brandon_brooks": {
    player_name: "Brandon Brooks",
    image_url:
      "https://image.maxpreps.io/rosters/dda64431-2648-4256-9dd3-2e626fa044dd/7/d/8/7d8c0864-cf60-45ed-9571-0281157ff918/original.jpg",
  },
  "61daylan_jackson": {
    player_name: "Daylan Jackson",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2023/11/Malachi-Booker-Prep-Hoops-Article.jpg?w=768",
  },
  "62tristan_coleman": {
    player_name: "Tristan Coleman",
    image_url:
      "https://sportspassports.com/wp-content/uploads/player-profiles/tristan-coleman_46844.jpg",
  },
  "75brodrick_wyatt": {
    player_name: "Brodrick Wyatt",
    image_url:
      "https://pbs.twimg.com/profile_images/1732868637071900673/4X0otdjP_400x400.jpg",
  },
  "77galen_roberts": {
    player_name: "Galen Roberts",
    image_url:
      "https://pbs.twimg.com/profile_images/1725435732595032064/ChMtvvbI_400x400.jpg",
  },
  "81josiah_jones": {
    player_name: "Josiah Jones",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/03/tempImageaxVIb8-rotated.jpg?w=768",
  },
  "88carter_coleman": {
    player_name: "Carter Coleman",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/05/IMG_6245.jpg?w=768",
  },
  "96christopher_hunt": {
    player_name: "Christopher Hunt",
    image_url:
      "https://prephoops.com/wp-content/uploads/sites/2/2024/03/IMG_2584.jpg?w=480",
  },
};
const possible_games = [
  "Top 30 Black vs Top 30 White",
  "Section 7 Game 1",
  "Section 7 Game 2",
  "Section 7 Game 3",
  "Prime Event Game 1",
  "Prime Event Game 2",
  "Prime Event Game 3",
  "Heart of Texas Game 1",
  "Heart of Texas Game 2",
  "Heart of Texas Game 3",
  "Heart of Texas Game 4",
  "Memorial Classic Game 1",
  "Memorial Classic Game 2",
  "Memorial Classic Game 3",
];

const possible_actions = [
  "assist",
  "field goal",
  "three pointer",
  "free throw",
  "rebound",
  "steal",
  "turnover",
  "block",
  "foul",
  "violation",
  "timeout",
  "substitution",
  "pass",
  "dribble",
  "drive",
  "dunk",
  "missed 2",
  "missed 3",
  "missed free throw",
];
export const gameFootage = {
  assists: [
    { duration: "12s", image: "", timestamp: "00:15:23" },
    { duration: "27s", image: "", timestamp: "00:32:10" },
    { duration: "9s", image: "", timestamp: "00:45:58" },
    { duration: "18s", image: "", timestamp: "01:12:34" },
    { duration: "21s", image: "", timestamp: "01:35:47" },
  ],
  field_goals: [
    {
      duration: "14s",
      image: "",
      timestamp: "00:05:41",
      lead_up_actions: ["rebound", "assist"],
      game: "Memorial Classic Game 1",
      action: "made 2pts",
    },
    { duration: "22s", image: "", timestamp: "00:20:56" },
    { duration: "10s", image: "", timestamp: "00:38:14" },
    { duration: "19s", image: "", timestamp: "00:52:30" },
    { duration: "25s", image: "", timestamp: "01:23:05" },
    { duration: "11s", image: "", timestamp: "01:45:20" },
  ],
  threes: [
    { duration: "17s", image: "", timestamp: "00:12:09" },
    { duration: "23s", image: "", timestamp: "00:29:41" },
    { duration: "8s", image: "", timestamp: "00:48:17" },
    { duration: "16s", image: "", timestamp: "01:27:52" },
  ],
  free_throws: [
    { duration: "15s", image: "", timestamp: "00:19:30" },
    { duration: "26s", image: "", timestamp: "01:09:42" },
  ],
  rebounds: [
    { duration: "12s", image: "", timestamp: "00:08:10" },
    { duration: "18s", image: "", timestamp: "00:37:24" },
    { duration: "9s", image: "", timestamp: "00:56:35" },
    { duration: "22s", image: "", timestamp: "01:11:57" },
    { duration: "14s", image: "", timestamp: "01:38:06" },
    { duration: "25s", image: "", timestamp: "01:50:12" },
  ],
  steals: [{ duration: "13s", image: "", timestamp: "00:34:25" }],
  turnovers: [{ duration: "11s", image: "", timestamp: "00:59:17" }],
};
export const gameFootage2 = {
  assists: [
    {
      duration: "12s",
      image: "",
      timestamp: "00:15:23",
      lead_up_actions: ["pass", "dribble"],
      game: "Heart of Texas Game 1",
      action: "assist",
    },
    {
      duration: "27s",
      image: "",
      timestamp: "00:32:10",
      lead_up_actions: ["dribble", "drive"],
      game: "Section 7 Game 2",
      action: "assist",
    },
    {
      duration: "9s",
      image: "",
      timestamp: "00:45:58",
      lead_up_actions: ["rebound", "pass"],
      game: "Prime Event Game 1",
      action: "assist",
    },
    {
      duration: "18s",
      image: "",
      timestamp: "01:12:34",
      lead_up_actions: ["drive", "assist"],
      game: "Memorial Classic Game 2",
      action: "assist",
    },
    {
      duration: "21s",
      image: "",
      timestamp: "01:35:47",
      lead_up_actions: ["steal", "pass"],
      game: "Top 30 Black vs Top 30 White",
      action: "assist",
    },
    {
      duration: "14s",
      image: "",
      timestamp: "01:48:22",
      lead_up_actions: ["foul", "free throw"],
      game: "Heart of Texas Game 4",
      action: "assist",
    },
    {
      duration: "19s",
      image: "",
      timestamp: "02:05:30",
      lead_up_actions: ["turnover", "steal"],
      game: "Section 7 Game 3",
      action: "assist",
    },
  ],
  field_goals: [
    {
      duration: "14s",
      image: "",
      timestamp: "00:05:41",
      lead_up_actions: ["rebound", "assist"],
      game: "Memorial Classic Game 1",
      action: "made 2pts",
    },
    {
      duration: "22s",
      image: "",
      timestamp: "00:20:56",
      lead_up_actions: ["dribble", "pass"],
      game: "Prime Event Game 3",
      action: "made 2pts",
    },
    {
      duration: "10s",
      image: "",
      timestamp: "00:38:14",
      lead_up_actions: ["pass", "assist"],
      game: "Heart of Texas Game 2",
      action: "made 2pts",
    },
    {
      duration: "19s",
      image: "",
      timestamp: "00:52:30",
      lead_up_actions: ["steal", "fast break"],
      game: "Section 7 Game 1",
      action: "made 2pts",
    },
    {
      duration: "25s",
      image: "",
      timestamp: "01:23:05",
      lead_up_actions: ["drive", "crossover"],
      game: "Top 30 Black vs Top 30 White",
      action: "made 2pts",
    },
    {
      duration: "11s",
      image: "",
      timestamp: "01:45:20",
      lead_up_actions: ["assist", "pass"],
      game: "Memorial Classic Game 3",
      action: "made 2pts",
    },
    {
      duration: "16s",
      image: "",
      timestamp: "02:10:12",
      lead_up_actions: ["dribble", "drive"],
      game: "Prime Event Game 2",
      action: "made 2pts",
    },
  ],
  rebounds: [
    {
      duration: "12s",
      image: "",
      timestamp: "00:08:10",
      lead_up_actions: ["missed 3", "box out"],
      game: "Prime Event Game 1",
      action: "rebound",
    },
    {
      duration: "14s",
      image: "",
      timestamp: "00:22:45",
      lead_up_actions: ["missed 2", "positioning"],
      game: "Memorial Classic Game 3",
      action: "rebound",
    },
    {
      duration: "10s",
      image: "",
      timestamp: "00:37:12",
      lead_up_actions: ["missed free throw", "hustle"],
      game: "Section 7 Game 1",
      action: "rebound",
    },
    {
      duration: "13s",
      image: "",
      timestamp: "01:02:30",
      lead_up_actions: ["missed 3", "box out"],
      game: "Heart of Texas Game 2",
      action: "rebound",
    },
  ],
  steals: [
    {
      duration: "13s",
      image: "",
      timestamp: "00:25:42",
      lead_up_actions: ["defensive pressure", "intercept pass"],
      game: "Memorial Classic Game 2",
      action: "steal",
    },
    {
      duration: "15s",
      image: "",
      timestamp: "01:05:32",
      lead_up_actions: ["intercept pass", "fast break"],
      game: "Prime Event Game 1",
      action: "steal",
    },
  ],
  turnovers: [
    {
      duration: "10s",
      image: "",
      timestamp: "00:44:18",
      lead_up_actions: ["bad pass", "miscommunication"],
      game: "Section 7 Game 3",
      action: "turnover",
    },
    {
      duration: "12s",
      image: "",
      timestamp: "01:30:50",
      lead_up_actions: ["steal by opponent", "double team"],
      game: "Heart of Texas Game 4",
      action: "turnover",
    },
  ],
};

export const getAllGameFootageSortedByTime = (gameFootage) => {
  // Flatten all stat categories into a single array
  const allFootage = Object.entries(gameFootage).reduce(
    (acc, [statType, plays]) => {
      // Add statType to each play object for reference
      const playsWithType = plays.map((play) => ({
        ...play,
        statType,
      }));
      return [...acc, ...playsWithType];
    },
    []
  );

  // Sort by timestamp
  return allFootage.sort((a, b) => {
    // Convert timestamp strings to comparable values (seconds)
    const getSeconds = (timestamp) => {
      const [hours, minutes, seconds] = timestamp.split(":").map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    };

    return getSeconds(a.timestamp) - getSeconds(b.timestamp);
  });
};
